import React, { useState, useRef, useEffect,useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactTabulator } from 'react-tabulator';
import DatePicker from "react-datepicker";
import {Card} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import "tabulator-tables/dist/css/tabulator_semanticui.min.css"; 
import { jwtDecode } from 'jwt-decode';
import loader from '../../assets/img/loading.gif'
import API from '../../api/api.jsx';
import { API_BASE_URL } from '../../config/app-axios.jsx';
import { clearUserState } from '../../reducers/userReducers.jsx';
import { clearMenuState } from '../../reducers/menuReducers.jsx';
import { clearLangCodeState } from '../../reducers/langCodeReducers.jsx';
import { getUserInfo } from '../../reducers/selectors/selectors.jsx';
import { store } from '../../store.jsx';

// Tabulator columns 목록
function formatLoanReceivableId(id) {
	if (!id ) return id; // id가 비어있거나 길이가 8 미만인 경우 그대로 반환
	return `${id.slice(0, 6)}-${id.slice(6, 9)}-${id.slice(9, 15)}-${id.slice(15)}`;
}

const initializeColumns = (t) => {
	return [
		{formatter:"rowSelection", titleFormatter:"rowSelection", headerHozAlign: 'center', hozAlign:"center", headerSort:false, width:30, cellClick:function(e, cell){
			cell.getRow().toggleSelect();
		}},				
		{ title: t('COLLECTION_MANAGEMENT.입금일자', { defaultValue: '입금일자' }), field: 'repayment_date', headerHozAlign: 'center', hozAlign: 'center', width:180, formatter:function(cell, formatterParams, onRendered){
			var value = cell.getValue();
			value = moment(value).format("DD/MM/YYYY");
			return value;
		} },
		{ title: t('COLLECTION_MANAGEMENT.계좌번호', { defaultValue: '계좌번호' }), field: 'account_number', headerHozAlign: 'center', hozAlign: 'center', width:150 },
		{ title: t('COLLECTION_MANAGEMENT.성명', { defaultValue: '성명' }), field: 'name', headerHozAlign: 'center', hozAlign: 'center', width:160, formatter: function (cell, formatterParams, onRendered) {
			cell.getElement().style.fontWeight = 'bold';
			return cell.getValue();
		} },
		// { title: `<i class="fa-solid fa-link"></i> ${t('COLLECTION_MANAGEMENT.계약번호', { defaultValue: '계약번호' })}`, field: 'loan_receivable_id', headerHozAlign: 'center', hozAlign: 'center', width:200 ,
		// 	formatterParams:{
		// 		urlPrefix:"/bond/detail/loanReceivableId=", // URL 커스텀
		// 	},
		// 	formatter: function(cell, formatterParams, onRendered){
		// 		// let value = cell.getValue();
		// 		let value = cell.getValue();
		// 		let href  = `${formatterParams["urlPrefix"]}${value}`;
		// 		value = value.slice(0, 6) + '-' + value.slice(6, 9) + '-' + value.slice(9, 15) + '-' + value.slice(15);

		// 		return `<a href="${href}" style="text-decoration: none; font-weight: bold; color: green;">${value}</a>`
		// 	}
		// },	
	    { title: `<i class="fa-solid fa-link"></i> ${t('COLLECTION_MANAGEMENT.계약번호', { defaultValue: '계약번호' })}`, field: 'loan_receivable_id', headerHozAlign: 'center', hozAlign: 'center', width:200 ,
		// { 
		// 	title: `<i class="fa-solid fa-link"></i> ${loanReceivableIdFieldName}`, 
		// 	field: 'loan_receivable_id', 
		// 	headerHozAlign: 'center', 
		// 	hozAlign: 'center', 
		// 	width:200, 
		 	formatter: function(cell){
				let value = cell.getValue();
				let displayValue = value.slice(0, 6) + '-' + value.slice(6, 9) + '-' + value.slice(9, 15) + '-' + value.slice(15);

				return `<span style="cursor:pointer; font-weight:bold; color:green; text-decoration:underline;">${displayValue}</span>`;
			},
			cellClick: function(e, cell) {
				const value = cell.getValue();
				// App 레이아웃 없는 standalone 페이지 열기
				const url = `/bond/bond_002_01?loanReceivableId=${value}`;
				const width = 1200;
				const height = 800;

				// 화면 크기 가져오기
				const screenWidth = window.screen.width;
				const screenHeight = window.screen.height;

				// 가운데 위치 계산
				const left = (screenWidth - width) / 2;
				const top = (screenHeight - height) / 2;

				// 팝업 열기
				window.open(
					url,
					"_blank",
					`width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
				);
			}
		},	
		{ title: t('LOAN_RECEIVABLE_INQUIRY.수납채널', { defaultValue: '수납채널' }), field: 'repayment_channel', headerHozAlign: 'center', hozAlign: 'center', width: 100 },
		{ title: t('COLLECTION_MANAGEMENT.거래번호', { defaultValue: '거래번호' }), field: 'repayment_id', headerHozAlign: 'center', hozAlign: 'right', width:200 },
		{ title: t('COLLECTION_MANAGEMENT.입금금액', { defaultValue: '입금금액' }), field: 'repayment_amount', headerHozAlign: 'center', hozAlign: 'right', width:150, formatter:"money", formatterParams:{ decimal:",", thousand:".", negativeSign:true, precision:false }, bottomCalc: "sum", bottomCalcFormatter: "money", bottomCalcFormatterParams: { decimal:",", thousand:".", negativeSign:true, precision:false } },
		{ title: t('COLLECTION_MANAGEMENT.적요', { defaultValue: '적요' }), field: 'remark', headerHozAlign: 'center', hozAlign: 'center', width:300 },
		// { title: '지점', field: '', headerHozAlign: 'center', hozAlign: 'center', width:120 },
	];
};

// 수납내역
const Acct002 = () => {
	const { t,i18n }  = useTranslation();
	const dispatch    = useDispatch();
	const oneMonthAgo = new Date();
    const tableRef    = useRef(null);

	// 초기 값
	const [loading, setLoading]                       = useState(false);
	const [startDate, setStartDate]                   = useState(oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1));
	const [endDate, setEndDate]                       = useState(new Date());
	const [name, setName]                             = useState('');
	const [selectOptions,setSelectOptions]            = useState([]);
	const [repaymentChannel, setRepaymentChannel]     = useState('');
	const [rowsPerPage, setRowsPerPage]               = useState(20);
	const [filterField, setFilterField]               = useState('name');
	const [filterType, setFilterType]                 = useState('like');
	const [filterValue, setFilterValue]               = useState('');
	const [columns, setColumns]                       = useState(initializeColumns(t));
	const [totalCount, setTotalCount]                 = useState(0);

	// remote 방식에 따른 페이징 처리
	const apiUrl                                      = API_BASE_URL;
	const userInfo                                    = getUserInfo(store.getState());
	const [branchType, setBranchType]                 = useState(userInfo.branch_type);
	const token                                       = userInfo?.access_token;
	const [selectBranch,setSelectBranch]              = useState('');
	const [selectOptions1,setSelectOptions1]          = useState([]);

	// 지점 정보 변경
	const handleChangeBranch = (e) => {
		setSelectBranch(e.target.value);
	};

	// ①. 강제로 쿠키 삭제를 통한 로그인 정보가 없는 경우
    const persistInfo = sessionStorage.getItem('persist:login');

    if (!persistInfo) {
        window.location.href = '/login';
    };

	// ②. 토큰 만료 체크 루틴
	if (token) {
		const decodedToken            = jwtDecode(token);
		const expirationTimeInSeconds = decodedToken.exp;
		const currentTimeInSeconds    = Math.floor(Date.now() / 1000);

		if (expirationTimeInSeconds < currentTimeInSeconds) {
			// 토큰이 만료되었을 경우 로그인 페이지로 리디렉션
			dispatch(clearUserState());
			dispatch(clearMenuState());
			dispatch(clearLangCodeState());
			localStorage.removeItem('langCodeInfo');
			window.location.href = '/login';
		};
	};


	// 액션 등을 구현
	// 수납채널 변경
	const handleChangeChannel = (e) => {
		setRepaymentChannel(e.target.value);
	};

	// 시작일 값 변경
	const handleChangeStartDate = (date) => {
		setStartDate(date);
	};

	// 종료일 값 변경
	const handleChangeEndDate = (date) => {
		setEndDate(date);
	};

	// 성명 변경
	const handleNameChange = (newName) => {
		setName(newName);
	};

	// 접수 채널 선택 옵션
	const fetchBaseOptions = async () => {			
		try {
			const data = await API.fetchBaseOptions();
			
			const options  = data.filter(item => item.code_nick_name === '수납채널');
			const result   = options.map(item => [item.code,item.code_se]);

			const options1      = data.filter(item => item.code_nick_name === '지점');
			const SelectOptions = options1.map(item => [item.code,item.code_se]);
			
			setSelectOptions(result);
			setSelectOptions1(SelectOptions);

			if (SelectOptions.length === 1) {
				setSelectBranch(SelectOptions[0][0]);
			};

		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// i18 선택된 언어에 따라 필요한 필드 값 번역
	const translateItem = useCallback((item, language) => ({
		...item,
		repayment_channel : item.repayment_channel ? t(`REPAYMENT_CHANNEL.${item.repayment_channel}`, { lng: language }) : '',
	}), [t]);

	// Tabulator Options
	// options 객체를 상태로 관리
	const [options, setOptions] = useState({
		ajaxURL     : `${apiUrl}/acct/acct_002`,
		ajaxConfig  : {
			method  : 'GET',
			headers : {
				'Content-Type' : 'application/json',
				'Authorization': `Bearer ${token}`,
			},
		},
		ajaxParams : {
			startDate        : moment(startDate).format('YYYY-MM-DD'),
			endDate          : moment(endDate).format('YYYY-MM-DD'),
			repaymentChannel : repaymentChannel,
			name             : name,
			branch_code      : selectBranch,
			page             : tableRef.current && tableRef.current.table ? tableRef.current.getPage() : 1,
			size             : tableRef.current && tableRef.current.table ? tableRef.current.getPageSize() : 20, // 페이지 크기 정보
		},
		layout                 : "fitColumns",
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage,
		paginationSizeSelector : [20, 40, 60, 80, 100],
		ajaxResponse : function (url, params, response) {

			// 값이 변경되면 직접 타이핑 하는 성명 칸은 초기화시키기
			// setName('');

			const total_count    = response.total_count || 0;
			const translatedData = response.data.map(item => translateItem(item, i18n.language));
			const responseData   = {
				last_page : response.last_page,
				data      : translatedData,
			};

			setTotalCount(total_count);

			return responseData;
		}
	});

	// 로딩 중일 때 이전의 pagination 관련 정보를 유지하도록 설정
	const loadingOptions = {
		pagination             : true,
		paginationMode         : "remote",
		paginationSize         : rowsPerPage, // 이전 페이지 사이즈를 유지
		paginationSizeSelector : [20, 40, 60, 80, 100],
	};

	// 조회 버튼 작동 시 실행되는 함수
	const handleQuery = useCallback(
		async () => {
			setLoading(true);

			// ReactTabulator의 내부 로직을 사용하여 API 호출
			try {
				// ReactTabulator에서 사용하는 API URL과 Params를 사용하여 호출
				const url  = new URL(options.ajaxURL);
				url.search = new URLSearchParams({
					...options.ajaxParams,
					name : name,
					page : tableRef.current?.getPage(),     // 현재 페이지 정보
					size : tableRef.current?.getPageSize(), // 페이지 크기 정보
				});

				const data = await fetch(url, {
					method  : options.ajaxConfig.method,
					headers : options.ajaxConfig.headers,
				});

				const responseData = await data.json();

				// 전달 받은 총 데이터 건수
				const total_count = responseData.total_count || 0;
		
				// 번역이 필요한 부분
				const translatedData = responseData.data.map(item => translateItem(item, i18n.language));
		
				// 페이징 및 데이터 리턴
				const updatedData = {
					last_page : responseData.last_page, // 전체 페이지 수 계산
					data      : translatedData, // 실제 테이블 데이터
				};

				// 총 건수를 화면에 표현하기 위해서
				setTotalCount(total_count);

				// 데이터 변경
				if (tableRef.current) {
					tableRef.current.setData(updatedData.data || []);
				}

				setLoading(false);

			} catch (error) {
				console.error('Error in fetchAcct002Data : ', error);
				setLoading(false);
			} 
		}, [options, name, i18n.language, translateItem]
	);

	// Filter 값에 따른 Tabulator 변화가 일어나는 함수
	const updateFilter = () => {
		if (tableRef.current) {
			tableRef.current.setFilter(filterField, filterType, filterValue);
		}
	};

	// value값을 입력할 때마다 해당되는 Tabulator가 화면에 보이도록 함수호출하는 부분
	const handleKeyUp = () => {
		updateFilter();
	};

	// 조회 조건이 바뀜에 따라 ajaxParams 동적 변경
	useEffect(() => {
		setOptions((prevOptions) => {
			const updatedOptions = {
				...prevOptions,
				ajaxParams: {
					...prevOptions.ajaxParams,
					startDate   : moment(startDate).format('YYYY-MM-DD'),
					endDate     : moment(endDate).format('YYYY-MM-DD'),
					name        : name,
					branch_code : selectBranch
				},
			};
			return updatedOptions;
		});
	}, [startDate, endDate, selectBranch]);

	// 수납채널 불러오기
	useEffect(() => {
		fetchBaseOptions();
	}, []);

	// 조회 조건이 바뀜에 따라 ajaxParams 동적 변경
	useEffect(() => {
		setOptions((prevOptions) => {
			const updatedOptions = {
				...prevOptions,
				ajaxParams: {
					...prevOptions.ajaxParams,
					repaymentChannel : repaymentChannel,
					startDate        : moment(startDate).format('YYYY-MM-DD'),
					endDate          : moment(endDate).format('YYYY-MM-DD'),
				},
			};
			return updatedOptions;
		});
	}, [repaymentChannel, startDate, endDate]);

	useEffect(() => {
		setColumns(initializeColumns(t))
	}, [i18n.language, t, handleQuery]);

	// 화면 UI
	return (
		<Card style={{ height: '100%' }}>
			<Card.Header><strong>{t('COLLECTION_MANAGEMENT.수납내역', { defaultValue: '수납내역' })}</strong></Card.Header>
			<Card.Body className='responsive-card-body'>
				<div className="panel-body">
					<div className="row ms-0">
						<div className="form-group col-lg-2 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
							<label className="form-label" htmlFor="site_code_id">
								<i className="bi bi-buildings "></i> {t('LOAN_RECEIVABLE_INQUIRY.수납채널', { defaultValue: '수납채널' })}
							</label>

							<select 
								className="form-select" 
								onChange={handleChangeChannel}
								value={repaymentChannel}
								id="site_code_id"
							>
								<option value="">{t('COMMON.전체', { defaultValue: '전체' })}</option>
								{selectOptions.map((option, index) => (
									<option key={index} value={option[0]}>
										{t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })}
									</option>
								))}
							</select>
						</div>

						<div className="form-group col-lg-3 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
							<label className="form-label" htmlFor="date_id">
								<i className="bi bi-calendar3"></i> {t('COLLECTION_MANAGEMENT.입금일자', { defaultValue: '입금일자' })}
							</label>

							<div className="input-group input-daterange">
								<div className='col'>
									<DatePicker
										className='form-control'
										selected={startDate}
										onChange={handleChangeStartDate}
										dateFormat="dd/MM/yyyy"
									/>
								</div>

								<div className="col-auto">
									<span className="input-group-text input-group-addon"> ~ </span>
								</div>

								<div className='col'>
									<DatePicker
										className='form-control'
										selected={endDate}
										onChange={handleChangeEndDate}
										dateFormat="dd/MM/yyyy"
									/>
								</div>
							</div>
						</div>

							<div className="form-group col-lg-2 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
								<label className="form-label" htmlFor="name">
									<i className="bi bi-pen"></i> {t('COLLECTION_MANAGEMENT.성명', { defaultValue: '성명' })}
								</label>
								<input className="form-control" type="text" id="name" value={name} onChange={(e) => handleNameChange(e.target.value)} />
							</div>

							<div className="form-group col-lg-2 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
								<label className="form-label" htmlFor="acct_nickname_id">
									<i className="bi bi-pen"></i> {t('LOAN_APPLICATION.지점', { defaultValue: '지점' })}
								</label>
								<select onChange={handleChangeBranch} value={selectBranch} className="form-select" id="site_code_id">
									{branchType === 'HEAD' 
										? <option value="">{t('COMMON.전체', { defaultValue: '전체' })}</option>
										: ''
									}
									{selectOptions1.map((option, index) => (
										<option key={index} value={option[0]}>
											{/* {t(`${option[1]}.${option[0]}`, { defaultValue: `${option[0]}` })} */}
											{option[1]}											
										</option>
									))}
								</select>
							</div>

							<div className="form-group col-lg-2 col-md-12 col-xs-12"></div>

							<div className="form-group col-lg-1 col-md-12 col-xs-12 ps-0 rounded-2">
								<div className="mb-3"></div>
								<button type="button" className="btn btn-success float-end float-bottom w-100 h-30.5px align-baseline mt-8px" onClick={handleQuery}>{t('LOAN_APPLICATION.조회', { defaultValue: '조회' })}</button>
							</div>

							<div className="mt-3 mb-3 ps-0">
								<i id="filter-icon" className="cursor-pointer fa fa-plus-square" data-bs-toggle="collapse" href="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></i>
								<span> Filter</span>
							</div>

							<div className="collapse show" id="collapseExample">
								<div className="row">
									<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 rounded-2 mb-1">
										<select 
											id="filter-field" 
											className="form-select col-sm-3" 
											value={filterField}
											onChange={(e) => setFilterField(e.target.value)}
										>								
											<option value="name">{t('COLLECTION_MANAGEMENT.성명', { defaultValue: '성명' })}</option>	
											<option value="account_number">{t('COLLECTION_MANAGEMENT.계좌번호', { defaultValue: '계좌번호' })}</option>
											<option value="loan_receivable_id">{t('COLLECTION_MANAGEMENT.계약번호', { defaultValue: '계약번호' })}</option>
											<option value="repayment_channel">{t('LOAN_RECEIVABLE_INQUIRY.수납채널', { defaultValue: '수납채널' })}</option>
											<option value="repayment_id">{t('COLLECTION_MANAGEMENT.거래번호', { defaultValue: '거래번호' })}</option>
											<option value="remark">{t('COLLECTION_MANAGEMENT.적요', { defaultValue: '적요' })}</option>

										</select>
									</div>
						
									<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 rounded-2 mb-1">
										<select 
											id="filter-type" 
											className="form-select col-sm-3"
											value={filterType}
											onChange={(e) => setFilterType(e.target.value)}
										>
											<option value="like">LIKE</option>
											<option value="=">=</option>
											<option value="<">&lt;</option>
											<option value="<=">&le;</option>
											<option value=">">&gt;</option>
											<option value=">=">&ge;</option>
											<option value="!=">!=</option>
										</select>
									</div>
						
									<div className="form-group col-lg-2 col-md-12 col-xs-12 ps-0 rounded-2 mb-1">
										<input 
											id="filter-value" 
											type="text" 
											className="form-control col-sm-6" 
											name="filter-value" 
											placeholder={t('COMMON.검색할 내용을 입력하세요', { defaultValue: '검색할 내용을 입력하세요' })}
											value={filterValue}
											onChange={(e) => setFilterValue(e.target.value)}
											onKeyUp={handleKeyUp}
										/>
									</div>
								</div>
							</div>
						</div>
					{/* </form> */}
				</div>

				{/* 로딩 관련 gif */}
				{loading && 
					<div
						style={{
							position: 'fixed',
							top: '50%',
							left: '55%',
							transform: 'translate(-50%, -50%)',
							zIndex: 9999,
						}}
					>
						<img src={loader} alt="Loading..." />
					</div>
				}

				{/* Tabulator */}
				<div id="tabulator-total-info" className='d-flex justify-content-end fw-bold'>{t(`LOAN_APPLICATION.총 {{count}}건`, { count: totalCount, defaultValue: '총 {{count}}건' })}</div>
				<ReactTabulator
					key         = {i18n.language + JSON.stringify(columns) + JSON.stringify(options)} // 언어 변경 및 옵션 변경에 따라 컴포넌트 리렌더링
					onRef       = {(r) => (tableRef.current = r.current)}
					columns     = {columns}
					options     = {loading ? loadingOptions : options} // 로딩 중일 때는 이전의 pagination 관련 정보를 유지하고 데이터를 변경하지 않도록 함
					placeholder = "No Data Found"
					className   = "responsive-tabulator"
				/>
			</Card.Body>

			<div className="card-footer d-flex justify-content-end mt-auto">
				{/* <button type="button" className="btn btn-outline-info mb-1 me-1 w-100px">버튼1</button>
				<button type="button" className="btn btn-outline-success me-1 mb-1 w-100px">버튼2</button> */}
			</div>
		</ Card>
	);
};

export default Acct002;